// Scrolls a home-page section into view, polling until it mounts and then
// re-correcting a few times while the rest of the page lays out.
//
// Used both by cross-page navigation (clicking a navbar/footer link from a
// founder profile navigates home, then this locks onto the target section once
// it renders) and by Home's mount effect for direct `/#section` URL loads.
//
// Uses setTimeout rather than requestAnimationFrame: rAF callbacks are throttled
// when the page isn't actively painting (e.g. headless/background contexts),
// which made the scroll silently no-op.
export function scrollToSection(id: string): void {
  if (!id || typeof document === "undefined") return;
  let waited = 0;
  let scrolls = 0;
  const tick = () => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView();
      scrolls++;
    }
    // Wait up to ~1.5s for the section to mount; once it does, re-correct a few
    // times (~200ms) to absorb layout settling, then stop so we don't fight the
    // user's own scrolling.
    if (scrolls < 4 && waited < 1500) {
      waited += 50;
      window.setTimeout(tick, 50);
    }
  };
  tick();
}
